<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>
            <pageheader [entity]="headerInviteeType"></pageheader>
        </h4>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="inviteetypes" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="inviteetypeColumns" [selectionField]="'Invitee_Type_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'"
            (downloadEntities)="onExcelExport()" (addEntity)="addInviteeType($event)"
            (editEntity)="editInviteeType($event)" (refreshEntities)="refreshInviteeType($event)"
            (deleteEntity)="deleteInviteeType($event)" (onPaginationChange)="onPaginationChange($event)"
            [serverPagination]="true" [pageSizes]="pageSizes" [pageSize]="defaultPageSize" [skip]="pageSkip"
            (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearInviteeType()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>

        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Invitee Type Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                        [fieldName]="'InviteeTypeName'" [(ngModel)]="entity.InviteeTypeName" ngDefaultControl></textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Code'" [mandatory]="true" [maxlength]="5" [formData]="entity"
                        [fieldName]="'Code'"  [(ngModel)]="entity.Code" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [mandatory]="false" [multiline]="true" [formData]="entity"
                        [maxlength]="500" [fieldName]="'Description'" [(ngModel)]="entity.Description" ngDefaultControl>
                    </textbox>
                </div>
            </div> 

            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div>
        </div>
        
    </div>
</div>

<kendo-excelexport [data]="inviteetypes.data" [collapsible]="true" fileName="InviteeType.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="InviteeTypeName" title="Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Description" title="Description" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Code" title="Order" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>